import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import DettaglioProdottoIntro from "./dettaglio-prodotto-intro";
import SliderImgProdotto from "./slider-img-prodotto";
import ProductTag from "./elements/product-tag";
import BannerPromoCM from "./banner-promo-cm";
import ReevooBadge from "./reevoo-badge";
import RepairabilityIndex from "./repairability-index";
import CircleMinus from "../icons/circle-minus-light.svg";
import CirclePlus from "../icons/circle-plus-light.svg";
import BannerPushNotification from "../components/elements/banner-push-notification";
import { getCampaignBoxes } from "../utility/campaigns";
import { getResultTags } from "../utility/discount-tag";
import useEnergyLabelLink from "../utility/energy-label-link";
import useNoRtl from "../hooks/use-no-rtl";
import { queryProductsDetails } from "../utility/ecommerce";
import { formatPrice } from "../utility/prices";
import { withPrefix } from "gatsby";
import ScrollLink from "./scroll-link";

const abTestCountries = [];
const pathPrefix = withPrefix("/");
const isAbTestCountry = abTestCountries.includes(pathPrefix);

const BabelProdottoIntro = ({
  babelProdotto,
  energyClassImg,
  config,
  productTitle,
  lineProductName2,
  readMoreDescription,
  location,
  labelManagerLabels,
  siteMetadata,
  liferayProductNotes,
  priceData,
  compareProducts,
  origin,
  storeLink,
  linkProductPage,
  bannerFeatures,
  enabledForLine,
  pagePath,
}) => {
  const {
    key_prod: productId,
    productCode,
    energyClass,
    minicard4,
    productDescBefore,
    productDescAfter,
    productApp,
    bannerNotification,
    repairabilityIndex,
    campaignsCard,
    productTags,
    campaignsPDP,
    campaignBadge,
    badgePdp,
    extraServices,
  } = babelProdotto;

  const [extraServicesProduct, setExtraServicesProduct] = useState();
  const noRtl = useNoRtl("pdp");

  const badge = useMemo(() => {
    //if (priceData === undefined) return [];
    return getResultTags(campaignBadge, badgePdp, config, priceData, enabledForLine, 3);
  }, [campaignBadge, badgePdp, config, priceData, enabledForLine]);

  const contributoRaee = useMemo(
    () =>
      priceData?.contributo_raee
        ? formatPrice(
            priceData.contributo_raee,
            priceData.sellingPrice.currency,
            siteMetadata.priceLanguage
          )
        : null,
    [priceData, siteMetadata.priceLanguage]
  );

  useEffect(() => {
    if (priceData?.extra_services) {
      if (typeof priceData.extra_services === "string") {
        // Magento
        const loadExtraServices = async () => {
          try {
            const items = await queryProductsDetails(priceData.extra_services.split(","));
            setExtraServicesProduct(items);
          } catch (err) {
            console.log("Error loading extra_services: ", err);
          }
        };
        loadExtraServices();
      } else if (extraServices?.length > 0) {
        const services = extraServices?.reduce((res, item) => {
          const extraServicesCheck = priceData.extra_services?.find(
            (service) => service?.sku?.split("_")?.[1] === item?.service_id
          );
          if (extraServicesCheck) {
            res.push({
              descriptionHtml: item?.description,
              name: item?.title,
              sku: extraServicesCheck?.sku,
              msrpPrice: extraServicesCheck?.msrpPrice,
              default: extraServicesCheck?.default,
            });
          }
          return res;
        }, []);
        setExtraServicesProduct(services); // CC
      } else {
        setExtraServicesProduct([]); // CC
      }
    }
  }, [priceData, extraServices]);

  const badgeFiltered = badge.filter((item) => item.id !== "general_discount");

  const LANG = useMemo(
    () => siteMetadata.priceLanguage.split("-")[0].toUpperCase(),
    [siteMetadata.priceLanguage]
  );
  const energyClassLink = useEnergyLabelLink(babelProdotto, LANG, config);

  const [description, setDescription] = useState(false);
  const toggleDescription = useCallback(() => setDescription((value) => !value), []);

  const campaignBoxesPromo = useMemo(
    () => getCampaignBoxes(campaignsPDP, priceData),
    [campaignsPDP, priceData]
  );
  const resultBannerPromoCm = campaignBoxesPromo.length && campaignBoxesPromo;

  const resultProductTags = useMemo(() => {
    return !noRtl
      ? getResultTags(campaignsCard, productTags, config, priceData, enabledForLine, 3)
      : getResultTags(campaignsCard, [], config, priceData, enabledForLine, 3);
  }, [campaignsCard, productTags, config, priceData, enabledForLine, noRtl]);

  return (
    <div className="container-fluid product-detail__container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="scroll-wrapper d-md-flex mb-5">
            <div className={`col-left align-self-start`}>
              <div className="d-flex flex-column d-md-none">
                <div className="d-flex align-items-center mb-2 product-detail__title-container">
                  <h1 className="product-detail__title-wrapper">
                    <span
                      className={classNames(
                        "product-detail__title mt-3",
                        (productDescBefore || minicard4.length) && "mb-0"
                      )}
                      dangerouslySetInnerHTML={{ __html: productTitle }}
                    ></span>
                    <span className="product-detail__code-energy-wrapper flex-wrap">
                      <span className="product-detail__code mr-3">{productCode}</span>

                      <span>
                        {energyClass &&
                          energyClass !== "-" &&
                          (energyClassLink ? (
                            <a href={energyClassLink} target="_blank" rel="noreferrer">
                              <img
                                src={energyClassImg}
                                className="icon-energy-rating"
                                alt={energyClass}
                              />
                            </a>
                          ) : (
                            <img
                              src={energyClassImg}
                              className="icon-energy-rating"
                              alt={energyClass}
                            />
                          ))}
                        {!!repairabilityIndex[0] && (
                          <RepairabilityIndex
                            data={
                              repairabilityIndex[0]?.product?.filter(
                                (index) => index.sku === productId
                              )[0]
                            }
                            lineId={babelProdotto.lineId}
                          />
                        )}
                      </span>
                    </span>
                  </h1>
                  {(!!config?.isReevooActiveFieldSet?.isReevooActive?.length ||
                    !!config?.isReevooActiveFieldSet?.isBazaarVoiceActive?.length) && (
                    <div className="ml-auto product-detail__reevoo">
                      <ReevooBadge productId={productId} productUrl={pagePath} />
                    </div>
                  )}
                </div>
                {/* </div>
              <h1
                className={classNames(
                  "product-detail__title",
                  (productDescBefore || minicard4.length) && "mb-0"
                )}
                dangerouslySetInnerHTML={{ __html: productTitle }}
              /> */}
                <div className={`mb-2 product-detail__desc${description ? " open" : ""}`}>
                  <div>
                    <p>
                      {productDescBefore
                        ? productDescBefore
                        : minicard4.length
                        ? lineProductName2
                          ? lineProductName2 + " " + minicard4.slice(0, 7).join(", ")
                          : minicard4.slice(0, 8).join(", ")
                        : ""}{" "}
                      {origin !== "AcModal" && !readMoreDescription && (
                        <ScrollLink href={`#technical-spec`} className="product-detail__view-st">
                          <span>{labelManagerLabels.seeAllTechnicalSpec}</span>
                        </ScrollLink>
                      )}
                      {readMoreDescription && !description ? "..." : ""}
                    </p>
                    {readMoreDescription && (
                      <button
                        onClick={toggleDescription}
                        className={description ? "d-none" : "d-inline-block"}
                        aria-label="open Button"
                      >
                        <CirclePlus />
                      </button>
                    )}
                  </div>
                  {readMoreDescription && (
                    <>
                      <div className="extended">
                        {productDescAfter
                          ? productDescAfter
                          : ", ".concat(minicard4.slice(lineProductName2 ? 7 : 8).join(", "))}
                        <button
                          onClick={toggleDescription}
                          aria-label="close Button"
                          className={description ? "d-inline-block less" : "d-none"}
                        >
                          <CircleMinus />
                        </button>
                      </div>
                    </>
                  )}
                  {origin !== "AcModal" && readMoreDescription && (
                    <ScrollLink href={`#technical-spec`} className="product-detail__view-st ml-0">
                      <span>{labelManagerLabels.seeAllTechnicalSpec}</span>
                    </ScrollLink>
                  )}
                </div>
                {!!resultBannerPromoCm.length && (
                  <div className="product-detail__promo product-detail__promo--gallery mt-2 mb-3">
                    <BannerPushNotification sleekNoteId="sn-785b13d4-ee9e-4fc6-acfe-e7bcc50e61dd">
                      <BannerPromoCM data={resultBannerPromoCm[0]} position="pdp" />
                    </BannerPushNotification>
                  </div>
                )}
              </div>
              <div className="text-center">
                <BannerPushNotification sleekNoteId="sn-785b13d4-ee9e-4fc6-acfe-e7bcc50e61dd">
                  {!!resultProductTags?.length && !noRtl && (
                    <div
                      className={classNames(
                        "prodotti__tags prodotti__tags--center py-3",
                        badgeFiltered?.length > 0 && "prodotti__tag--badge"
                      )}
                    >
                      {resultProductTags.map((item, i) => (
                        <ProductTag
                          data={item}
                          location={location}
                          key={i}
                          contributoRaee={contributoRaee}
                        />
                      ))}
                    </div>
                  )}
                </BannerPushNotification>
              </div>
              {/* Slider img prodotto with thumbs */}
              {isAbTestCountry ? (
                <>
                  <div
                    className={classNames(
                      "product-detail__slider",
                      !!babelProdotto.s3Images?.length && "product-detail__slider--standard"
                    )}
                  >
                    <SliderImgProdotto
                      data={babelProdotto}
                      labelManagerLabels={labelManagerLabels}
                      bannerPromoCM={resultBannerPromoCm}
                      bannerNotification={bannerNotification}
                      badge={badgeFiltered}
                      origin={origin}
                      pagePath={pagePath}
                    />
                  </div>
                  {!!babelProdotto.s3Images?.length && (
                    <div className="product-detail__slider product-detail__slider--enhanced">
                      <SliderImgProdotto
                        data={babelProdotto}
                        labelManagerLabels={labelManagerLabels}
                        bannerPromoCM={resultBannerPromoCm}
                        bannerNotification={bannerNotification}
                        badge={badgeFiltered}
                        enhanced={true}
                        origin={origin}
                        pagePath={pagePath}
                      />
                    </div>
                  )}
                </>
              ) : !isAbTestCountry && !!babelProdotto.s3Images?.length ? (
                <div className="product-detail__slider product-detail__slider--enhanced noabtest">
                  <SliderImgProdotto
                    data={babelProdotto}
                    labelManagerLabels={labelManagerLabels}
                    bannerPromoCM={resultBannerPromoCm}
                    bannerNotification={bannerNotification}
                    badge={badgeFiltered}
                    enhanced={true}
                    origin={origin}
                    pagePath={pagePath}
                  />
                </div>
              ) : (
                <div className={classNames("product-detail__slider")}>
                  <SliderImgProdotto
                    data={babelProdotto}
                    labelManagerLabels={labelManagerLabels}
                    bannerPromoCM={resultBannerPromoCm}
                    bannerNotification={bannerNotification}
                    badge={badgeFiltered}
                    origin={origin}
                    pagePath={pagePath}
                  />
                </div>
              )}
            </div>
            <div className="col-right">
              <DettaglioProdottoIntro
                data={{ ...babelProdotto, productTitle, compareProducts }}
                priceData={priceData}
                extraServices={extraServicesProduct}
                config={config}
                labelManagerLabels={labelManagerLabels}
                siteMetadata={siteMetadata}
                productApp={productApp}
                location={location}
                bannerNotification={bannerNotification}
                productNote={liferayProductNotes}
                contributoRaee={contributoRaee}
                storeLink={storeLink}
                origin={origin}
                linkProductPage={linkProductPage}
                bannerFeatures={bannerFeatures}
                pagePath={pagePath}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BabelProdottoIntro;
